export default __webpack_public_path__ + "static/media/wifi_unusable.f8a94f04.svg";